import React from 'react';

import {assert} from 'Asserts';
import {OBJECTS_CREATABLE_PERMISSION} from 'auth/PermissionConstants';
import {Label, Main, Pane, Step, Steps} from 'bulk-workflows/BulkWorkflowComponents';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import FolderSelector, {DEFAULT_PROJECT_FOLDER_LABEL_TEXT} from 'file-browser/FolderSelector';
import TagSchemaSelector from 'schemas/shared/TagSchemaSelector';
import FormGroup from 'ui-library/bs/FormGroup';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';
import {Cell, Column, Table} from 'ui-library/simple-table/SimpleTable';

// @ts-expect-error
import * as BulkAntibodyActions from './BulkAntibodyActions';
import {BioentityLinkSpec, BulkAntibody} from './BulkAntibodyConstants';
import BulkAntibodySummary from './components/BulkAntibodySummary';

const PROJECT_FOLDER_LABEL_TEXT = `Select output ${DEFAULT_PROJECT_FOLDER_LABEL_TEXT.toLowerCase()}`;

interface BioentityLinkTableProps {
  bioentityLinkSpec: BioentityLinkSpec;
}

function BioentityLinkTable({bioentityLinkSpec}: BioentityLinkTableProps): JSX.Element {
  return (
    <Table numRows={bioentityLinkSpec.files.length}>
      <Column
        header={bioentityLinkSpec.tagSchemaField.name}
        renderCell={(fileIndex) => <Cell>{bioentityLinkSpec.files[fileIndex].name}</Cell>}
      />
    </Table>
  );
}

interface BulkAntibodyEditorProps {
  bulkAntibody: BulkAntibody;
}

class BulkAntibodyEditor extends React.Component<BulkAntibodyEditorProps> {
  _handleTagSchemaChange = (tagSchema: {id: string} | null): void => {
    assert(tagSchema != null, 'TagSchemaSelector returned null for our tagSchema');
    BulkAntibodyActions.update({tagSchemaId: tagSchema.id});
  };

  _handleOutputFolderChange = (e: {target: {value: string}}): void => {
    BulkAntibodyActions.update({outputFolderId: e.target.value});
  };

  override render(): JSX.Element {
    // TODO(T8838): Refactor into child components once the bulk workflow UI components are fully implemented
    const {bulkAntibody} = this.props;
    return (
      <Main>
        <Pane>
          <Steps>
            <Step text="Create antibody files">
              <FormGroup>
                <Label>Antibody Schema</Label>
                <TagSchemaSelector
                  oligoAwareFolderItemTypes={[ModelTypeConstants.BASIC_FOLDER_ITEM]}
                  requiredPermissions={[OBJECTS_CREATABLE_PERMISSION]}
                  onChange={this._handleTagSchemaChange}
                  selectedTagSchemaId={bulkAntibody.tagSchemaId}
                />
              </FormGroup>
              <FormGroup>
                <Label>Antibody Fields</Label>
                {bulkAntibody.inputFilesLoading ? (
                  <div>
                    <HorizontalThrobber />
                  </div>
                ) : (
                  bulkAntibody.bioentityLinkSpecs.map((bioentityLinkSpec, bioentityLinkSpecIndex) => (
                    <BioentityLinkTable key={bioentityLinkSpecIndex} bioentityLinkSpec={bioentityLinkSpec} />
                  ))
                )}
              </FormGroup>
            </Step>
            <Step text={PROJECT_FOLDER_LABEL_TEXT}>
              <FolderSelector
                requireSubfolderCreatableAuth={true}
                showInventory={true}
                value={bulkAntibody.outputFolderId}
                onChange={this._handleOutputFolderChange}
                unsetOnFetchFail={true}
              />
            </Step>
          </Steps>
        </Pane>
        <Pane header="Antibody Summary">
          <BulkAntibodySummary bulkAntibody={bulkAntibody} />
        </Pane>
      </Main>
    );
  }
}

export default BulkAntibodyEditor;
